export default __webpack_public_path__ + "static/media/development.a88976cb.png";